export default {"src":"/_next/static/media/chevronDown.e59794c8.svg","height":9,"width":16};